module.exports = __webpack_public_path__ + "img/running.e4dbe173.svg";